import "core-js/modules/es.array.concat";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import { shopV2Store } from './shopV2';
var m = {
  namespaced: true,
  // @ts-ignore
  state: function state() {
    return {
      activityList: null,

      /** 礼品订单列表 */
      giftOrders: {},

      /** 订单详情 */
      orderDetail: {},
      detail: null,
      changeGift: {},
      aftersaleList: []
    };
  },
  mutations: {
    /**
     * 获取活动列表
     */
    setActivityList: function setActivityList(state, list) {
      state.activityList = list;
    },

    /**
     * 售后详情
     */
    setAftersaleDetail: function setAftersaleDetail(state, detail) {
      state.detail = detail;
    },

    /**
     * 我的售后
     */
    setAftersaleList: function setAftersaleList(state, aftersaleList) {
      state.aftersaleList = state.aftersaleList.concat(aftersaleList.data);
    },
    resetAftersaleList: function resetAftersaleList(state) {
      state.aftersaleList = [];
    },

    /**
     * 设置礼品订单列表和已发货礼品订单数量
     */
    setGiftOrders: function setGiftOrders(state, _a) {
      var activityId = _a.activityId,
          orders = _a.orders;
      Vue.set(state.giftOrders, activityId, orders);
    },

    /**
     * 设置订单详情
     */
    setOrderDetail: function setOrderDetail(state, _a) {
      var orderId = _a.orderId,
          order = _a.order;
      Vue.set(state.orderDetail, orderId, order);
    },

    /**
     * 订单详情
     */
    setChangeGift: function setChangeGift(state, _a) {
      var orderId = _a.orderId,
          geft = _a.geft;
      Vue.set(state.changeGift, orderId, geft);
    }
  },
  actions: {
    /**
     * 获取活动列表
     */
    getActivityList: function getActivityList(context) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/gift/activity_list')];

            case 1:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setActivityList', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     *  获取礼品订单列表
     * @param activityId 活动id
     */
    getGiftOrders: function getGiftOrders(_a, _b) {
      var commit = _a.commit;
      var activityId = _b.activityId,
          offset = _b.offset,
          count = _b.count;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/gift/orders', {
                params: {
                  activity_id: activityId,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (response.status === 200) {
                commit('setGiftOrders', {
                  activityId: activityId,
                  orders: rdata.data
                });
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    },

    /**
     * 获取订单详情
     */
    getOrderDetail: function getOrderDetail(_a, _b) {
      var commit = _a.commit;
      var orderId = _b.orderId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/gift/order_detail', {
                params: {
                  order_id: orderId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setOrderDetail', {
                  orderId: orderId,
                  order: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 查看可更换的礼品规格
     */
    getChangeGift: function getChangeGift(_a, _b) {
      var commit = _a.commit;
      var orderId = _b.orderId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/aftersale/get_change_gift', {
                params: {
                  order_id: orderId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setChangeGift', {
                  orderId: orderId,
                  geft: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     *  申请售后
     */
    aftersaleApply: function aftersaleApply(_a, params) {
      var commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/aftersale/apply', params)];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     *  申请售后
     */
    applyCancel: function applyCancel(_a, params) {
      var commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/aftersale/apply_cancel', params)];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     *  填写快递单号
     */
    addExpressCode: function addExpressCode(_a, params) {
      var commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/aftersale/add_express_code', params)];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     *  售后详情
     */
    aftersaleDetail: function aftersaleDetail(_a, params) {
      var commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/aftersale/detail', {
                params: params
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setAftersaleDetail', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     *  我的售后
     */
    getAftersaleList: function getAftersaleList(_a, params) {
      var commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/aftersale/index', {
                params: params
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setAftersaleList', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  },
  modules: {
    v2: shopV2Store
  }
};
export default m;